import { jsx as r } from "react/jsx-runtime";
import { c as o } from "./createSvgIcon.js";
const c = o(/* @__PURE__ */ r("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
export {
  c as A
};
